import {createAppProperties} from "./LocationUtil";
import {AppDispatch} from "../AppStore";
import {AppState} from "../AppState";
import {LocationProperties} from "../util/LocationParser";
import {ItemActions} from "../actions/ItemActions";
import {ContentLocation} from "./ContentLocation";
import {EmailActions} from "../actions/EmailActions";

export interface UsersLocationProperties {
    itemId?: number;
}

export const UsersLocationPropertyNames = createAppProperties<UsersLocationProperties>("itemId");

export class UsersLocation {

    static handleLocationChange(dispatch: AppDispatch, getState: () => AppState, newLocation: LocationProperties): void {

        const {usersState} = getState();

        const newUserDto = usersState.users.find(u => u.WebId === newLocation.itemId);
        if (newUserDto) {
            dispatch(ItemActions.showItemContent(newUserDto));
        } else {
            dispatch(EmailActions.clearItemContent());
        }
    }

    static selectUser(userId: number | undefined) {
        ContentLocation.showUserDto(userId);
    }
}
